import { createContext, useEffect, useCallback, useState } from "react";
import { Products } from "./products";
import { Productdata } from "./fetchProducts"


export const ShopContext = createContext(null);

const getDefaultCart = () => {
  let cart = {};
  for (let i = 1; i < 50 + 1; i++) {
    if (i === 1){
      cart[i] = 1;
    } else {
      cart[i] = 0;
    }
  }
  console.log(cart);
  return cart;
};

export const ShopContextProvider = (props) => {

  const [cartItems, setCartItems] = useState(() => {
    const storedCartItems = localStorage.getItem("cartItems");
    return storedCartItems ? JSON.parse(storedCartItems) : getDefaultCart();
  });

  const updatedProducts = Productdata();

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);


  const getTotalCartAmount = (inuseProducts) => {
    const productMap = inuseProducts.reduce((map, product) => {
      map[product.ID] = product;
      return map;
    }, {});
    let totalAmount = 0;
    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        let itemInfo = productMap[Number(item)];
        totalAmount += cartItems[item] * itemInfo.price;
      }
    }
    return totalAmount;
  };

  const addToCart = useCallback((itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] + 1 }));
    // setCartItems((prev) => {
    //   // Check if the item exists in the cart
    //   if (prev[itemId] > 0) {
    //     // Item exists, return the cart items unchanged
    //     return prev;
    //   } else {
    //     // Item doesn't exist, add it to the cart with quantity 1
    //     return { ...prev, [itemId]: 1 };
    //   }
    // });
  },[]);

  const removeFromCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));
  };

  const updateCartItemCount = (newAmount, itemId) => {
      setCartItems((prev) => ({ ...prev, [itemId]: newAmount }));
  };

  const checkout = useCallback(() => {
    // Clear localStorage on checkout
    try {
      localStorage.removeItem("cartItems");
    } catch (error) {
      console.error("Error clearing localStorage:", error.message);
      // Handle error gracefully (e.g., display a message to the user)
    }
  }, []);

  const contextValue = {
    updatedProducts,
    cartItems,
    addToCart,
    updateCartItemCount,
    removeFromCart,
    getTotalCartAmount,
    checkout,
  };

  return (
    <ShopContext.Provider value={contextValue}>
      {props.children}
    </ShopContext.Provider>
  );
};